import React from "react"
import { Grid, makeStyles } from "@material-ui/core/index"
import Img from "gatsby-image"
import { graphql, StaticQuery } from "gatsby"

export default function MemberPhoto({ photoName }) {
  const classes = useStyles()
  return (
    <StaticQuery
      query={query}
      render={data => {
        const photo = data.allFile.edges.filter(
          edge => edge.node.name === photoName
        )[0]
        return (
          <Grid container justify={"center"}>
            <Img
              fluid={photo.node.childImageSharp.fluid}
              alt={photoName}
              className={classes.image}
              loading={"lazy"}
            />
          </Grid>
        )
      }}
    />
  )
}

const useStyles = makeStyles(theme => ({
  image: {
    height: 150,
    width: 150,
    borderRadius: "50%",
  },
}))

export const query = graphql`
  query {
    allFile(
      filter: {
        sourceInstanceName: { eq: "member images" }
        extension: { eq: "jpeg" }
      }
    ) {
      edges {
        node {
          name
          sourceInstanceName
          childImageSharp {
            fluid {
              src
              sizes
              srcSet
              base64
              aspectRatio
            }
          }
        }
      }
    }
  }
`
